// extracted by mini-css-extract-plugin
export default {"root":"XN8MqJCYrui4jdKQJ6N0"};